import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;
// Actas de entregas > Registro de productos (PO)
const endpoint = "/api/financiero/fin_productos_po";

const getOrdenesServicioPO = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

// payload: { encabezado: { Numero_PO, oid_proveedor, fecha_entrega_po, observacion }, productos: [...] }
// El encabezado se replica en cada producto; se guarda todo o nada.
const createProductosPO = async (payload, usuario) => {
  const response = await axios.post(`${baseUrl}${endpoint}`, payload, {
    headers: { usuario }
  });
  return response.data;
};

const updateProductoPO = async (id, data, usuario) => {
  const response = await axios.put(`${baseUrl}${endpoint}/${id}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const deleteOrdenServicioPO = async (id, usuario) => {
  const response = await axios.delete(`${baseUrl}${endpoint}/${id}`, {
    headers: { usuario }
  });
  return response.data;
};

const leerPdfPO = async (file) => {
  const formData = new FormData();
  formData.append("pdf", file);
  const response = await axios.post(
    `${baseUrl}/api/financiero/leer-po-pdf`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

const getUnidadesMedidaPO = async () => {
  const response = await axios.get(`${baseUrl}/api/financiero/fin_unidad_medida`);
  return response.data;
};

export {
  getOrdenesServicioPO,
  createProductosPO,
  updateProductoPO,
  deleteOrdenServicioPO,
  leerPdfPO,
  getUnidadesMedidaPO
};
